/**
 * /login route — public auth ceremony entry (plan §6.8.11).
 */
import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '@/router-root';

import { LoginRoute } from './login-route';

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginRoute,
});
